import burger from '../assets/burger.svg'
import sbux from '../assets/sbux.svg'
import kfc from '../assets/kfc.svg'
import jco from '../assets/jco.svg'

export const Patners = [
    {
        image : burger,
        name : 'Burger King',
    },
    {
        image: sbux,
        name: 'Starbucks'
    },
    {
        image: kfc,
        name: 'Kfc'
    },
    {
        image: jco,
        name: 'JCO'
    },
]